export const ComponenteTipo = {
  GraphicalView: 0,
  TimeSeriesView: 1,
  TextView: 2,
  ImageView: 3,
  DialView: 4,
  ActionView: 5,
  TabelaSensoresVirtuais: 6,
  PipeView: 7,
  NavigationView: 8,
}

// Tipos de destino de cada entrada do componente de navegacao. Nao vao para o
// backend: sao usados so na UI para escolher qual sub-objeto (url/view/
// equipamento) a entrada preenche. Cada entrada preenche exatamente um.
export const NavigationTargetType = {
  Url: 'url',
  View: 'view',
  Equipamento: 'equipamento',
}

// Espelha os enums do backend (Flow.Core/Enums/Pipe*.cs). Os valores sao
// enviados/recebidos como inteiros (Newtonsoft serializa enums como int).
export const PipeLineStyle = {
  Unspecified: 0,
  Solid: 1,
  Dashed: 2,
  Dotted: 3,
}

export const PipeArrowDirection = {
  Unspecified: 0,
  None: 1,
  Forward: 2,
  Backward: 3,
  Both: 4,
}

export const PipeAnchorPosition = {
  Unspecified: 0,
  Center: 1,
  Top: 2,
  Right: 3,
  Bottom: 4,
  Left: 5,
}
